import React, { useState, useEffect, useMemo } from "react";
import { PayrollClient } from "services";

export const EmployeeContext = React.createContext({
  employee: null,
});

export const EmployeeContextProvider = ({ user, children }) => {
  const [employee, setEmployee] = useState(null);

  useEffect(() => {
    async function fsetEmployee() {
      setEmployee(null);

      if (!user) return;

      if (!user.employee) return;
 
      const payroll_client = PayrollClient();
      try {
        const employees = await payroll_client.get("employees/get_employees").get("data");
        if (employees.length > 0) setEmployee(employees[0]);
      } catch (ex) {
        console.error(ex);
      }
    }
    fsetEmployee();
  }, [user ? user.user_id : undefined]);

  const value = useMemo(() => ({ employee }), [employee]);

  return (
    <EmployeeContext.Provider value={value}>
      {children}
    </EmployeeContext.Provider>
  );
};

export default EmployeeContext;
